export default __webpack_public_path__ + "static/ship_compare_comp1_active-7d96d9550cc970d1a0b47c8fc50fdc96.png";